import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill";
import { fetchBlog, fetchSampleBlog } from "../../../actions/blogActions";
import { connect } from "react-redux";
import "./Story.css";
import NavbarClass from "../../NavbarClass";
import Footer from "../../footer/Footer";
import { localAPI } from "../../../api/local";
import { pageview } from "../../../utils/googleAnalyticsUtils";

class Story extends Component {
  async componentDidMount() {
    pageview('Story');
    if (!this.props.sample) {
      await this.props.fetchBlog(this.props.match.params.blogId);
    }
  }

  getBlogContent(blog) {
    return blog?.content ? blog.content : "";
  }

  render() {
    return (
      <div>
        <div className="story-outer-container">
          {!this.props.sample && <NavbarClass />}
          <div className="container story-container">
            <ReactQuill
              readOnly
              value={this.getBlogContent(this.props.sample ? this.props.sampleBlog : this.props?.blog)}
              modules={{ toolbar: null }}
              className="p-3"
            />
          </div>
          {!this.props.sample && (
            <Footer customStyles={{ position: "absolute", bottom: 0 }} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    blog: state.blogs?.blog?.blog,
    // userData: state.checkUser.userData,
    // type: state.type,
  };
};

export default connect(mapStateToProps, {
  fetchBlog,
  fetchSampleBlog,
})(Story);
